import Joi from 'joi';
export const UseRenameFolderSchema = Joi.object({

});
